import React from "react";
import EventCalendar from "../../assets/svgcomps/EventCalendarComp";
import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";
import ProfileImagePlaceHolder from "../../assets/images/profile_image_placeholder.png";
import moment from "moment";
import draftIcon from "../../assets/icons/draft_icon.svg";
import publishedIcon from "../../assets/icons/published_icon.svg";
import disabledIcon from "../../assets/icons/disabled_icon.svg";

type ProfileCardProps = {
  id?: number;
  displayName?: string;
  name?: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  availabilityStatus?: string;
  availableFrom?: string;
  onClick?: any;
  status?: string;
  isModificationAllowed: boolean;
};

const ProfileCard: React.FC<ProfileCardProps> = ({
  id,
  name,
  title,
  description,
  imageUrl,
  availabilityStatus,
  availableFrom,
  onClick,
  displayName,
  status,
  isModificationAllowed,
}) => {
  return (
    <div
      onClick={() => onClick(`/profile-detail/${displayName}`)}
      className="break-all relative bg-gray-50 border border-gray-300 rounded-lg p-3 flex flex-col items-center text-center cursor-pointer"
    >
      <div className="flex justify-end w-full">
        <div className="flex justify-center text-slate-950 h-[17px] items-center">
          <img
            className="w-fit mr-1"
            src={`${
              status?.toLocaleUpperCase() === CONSTANTS.PUBLISHED_TXT.toLocaleUpperCase()
                ? publishedIcon
                : status?.toLocaleUpperCase() === CONSTANTS.DRAFT_TXT.toLocaleUpperCase()
                ? draftIcon
                : disabledIcon
            }`}
            alt="status_icon"
          />
          <span
            className={`${
              status?.toLocaleUpperCase() === CONSTANTS.PUBLISHED_TXT.toLocaleUpperCase()
                ? "text-primary-light"
                : status?.toLocaleUpperCase() === CONSTANTS.DISABLED_TXT.toLocaleUpperCase()
                ? "text-[#656565]"
                : ""
            } text-[14px]`}
          >
            {status?.toLocaleUpperCase() === CONSTANTS.PUBLISHED_TXT.toLocaleUpperCase()
              ? CONSTANTS.PUBLISHED_TXT
              : status?.toLocaleUpperCase() === CONSTANTS.DRAFT_TXT.toLocaleUpperCase()
              ? CONSTANTS.DRAFT_TXT
              : CONSTANTS.DISABLED_TXT}
          </span>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center">
        <img
          className="w-[70px] h-[70px] rounded-full mb-2 min-h-[70px] object-cover"
          src={imageUrl || ProfileImagePlaceHolder}
          alt={`${name} profile`}
        />
        <div className="mb-5 h-[40px]">
          <div
            className={`border gap-1 font-medium px-3 py-1 mt-1 text-xs rounded mb-4 items-center ${
              availabilityStatus === CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
                ? "text-primary-dark"
                : availabilityStatus === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
                ? "#000000"
                : "text-orange"
            }`}
          >
            <div className="flex items-center">
              <EventCalendar
                fill={
                  availabilityStatus ===
                  CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
                    ? CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR
                    : availabilityStatus ===
                      CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
                    ? CONSTANTS.APP_DEFAULT_COLORS.BLACK_COLOR
                    : CONSTANTS.APP_DEFAULT_COLORS.ORANGE_COLOR
                }
              />
              <p className="m-1">
                {availabilityStatus ===
                CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
                  ? CONSTANTS.AVAILABILITY_IMMEDIATELY_TXT
                  : availabilityStatus === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
                  ? CONSTANTS.AVAILABLE_ON_DATE_TXT
                  : CONSTANTS.NOT_AVAILABLE_TXT}
              </p>
              {availabilityStatus === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT && (
                <p className="text-center">
                  {availableFrom && moment(availableFrom).format("DD MMM YY")}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="h-[125px] min-w-[250px] max-w-[100%]">
        <p className="text-gray-900 max-h-[25px] overflow-hidden text-ellipsis whitespace-nowrap m-auto" title={name}>{name}</p>
        <p className="text-sm text-gray-500 mb-3 h-[20px]">{title}</p>
        <p className="text-sm text-gray-500 mb-3 h-full max-h-[40px] overflow-hidden line-clamp-2">
          {description}
        </p>
      </div>
      <div className="flex w-full gap-2">
        {isModificationAllowed && (
          <Button
            on_click_handler={(e: Event) => {
              e.stopPropagation();
              onClick(`/modify-profile/${id}`);
            }}
            btn_label={CONSTANTS.MODIFY_PROFILE_TXT}
            type="secondary"
            other_classes="z-50 !bg-transparent border border-2 border-gray-300"
          />
        )}
      </div>
    </div>
  );
};

export default ProfileCard;
